<template>

  <div id="login-credentials-form" class="edit-form">
    <div class="row">
      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">

          <input type="text"
                 id="username"
                 class="form-control"
                 placeholder="Username"
                 name="username"
                 :data-vv-scope="validationScope"
                 data-vv-delay="1000"
                 v-model="uName"
                 v-validate="'required|min:6|max:60|hasSpecialCharacterValidator|verify-username'"
                 v-on:input="event => setValue('username', event.target.value)">
          <label for="username">Username</label>
          <span v-show="errors.has(validationScope + '.username')" class="help form-errors">
            {{ errors.first(validationScope + '.username') }}
          </span>

        </div>
      </div>

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">

          <input type="text"
                 id="email"
                 class="form-control"
                 placeholder="Email"
                 name="email"
                 :value="value.email"
                 v-on:input="event => setValue('email', event.target.value)"
                 :data-vv-scope="validationScope"
                 v-validate="'required|email'"
                 >
          <label for="email">Email</label>
          <span v-show="errors.has(validationScope + '.email')" class="help form-errors">
            {{ errors.first(validationScope + '.email') }}
          </span>

        </div>
      </div>
    </div>

    <div class="row">

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">

          <input class="form-control"
                 type="password"
                 :value="value.password"
                 ref="password"
                 id="password"
                 maxlength="14"
                 v-validate="'required|min:8|max:14|hasNumberValidator|hasUpperCaseValidator|hasLowerCaseValidator|hasUpperAndLowerLetterValidator'"
                 name="password"
                 placeholder="Password"
                 :data-vv-scope="validationScope"
                 v-on:input="event => setValue('password', event.target.value)"
                 :aria-invalid="errors.has(validationScope + '.newPassword')">

          <label for="password">Password</label>
          <span class="input-group-btn btn btn-view">
                      <button type="button" class="btn btn-link" v-on:click="togglePassword($refs.password)">
                          <i class="fa fa-eye" aria-hidden="true"></i>
                      </button>
                  </span>
          <span v-show="errors.has(validationScope + '.password')"
                class="help form-errors">{{ errors.first(validationScope + '.password') }}</span>

        </div>
        <div class="tooltips">
          <ul class="list-unstyled">
            <li>
              <h5 class="tooltip-title">Your password must have</h5>
            </li>
            <li :class="{ 'ok-check' : validateLength(value.password) }">
              <i class="fa fa-check-circle-o" aria-hidden="true"></i> 8 to 14 characters
            </li>
            <li :class="{ 'ok-check' : validateHasUpperAndLowerLetter(value.password) }">
              <i class="fa fa-check-circle-o" aria-hidden="true"></i> Upper and lowercase letters (e.g. Aa)
            </li>
            <li :class="{ 'ok-check' : validateHasANumber(value.password) }">
              <i class="fa fa-check-circle-o" aria-hidden="true"></i> At least one number (e.g. 1234)
            </li>
          </ul>
        </div>
      </div>

      <div class="materialized col-xs-12 col-sm-6">
        <div class="form-group materialized">

          <input class="form-control"
                 type="password"
                 id="confirmPassword"
                 name="confirmPassword"
                 :value="value.confirmPassword"
                 ref="confirmPassword"
                 maxlength="14"
                 v-validate="'required|min:8|max:14|confirmed:password'"
                 :data-vv-scope="validationScope"
                 v-on:input="event => setValue('confirmPassword', event.target.value)"
                 placeholder="Confirm New Password"
                 :aria-invalid="errors.has(validationScope + '.confirmPassword')">
          <label for="confirmPassword">Confirm Password</label>

          <span class="input-group-btn btn btn-view">
              <button type="button" class="btn btn-link" v-on:click="togglePassword($refs.confirmPassword)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
              </button>
          </span>
          <span v-show="errors.has(validationScope + '.confirmPassword')"
                class="help form-errors">{{ errors.first(validationScope + '.confirmPassword') }}</span>

        </div>
      </div>

    </div>
  </div>

</template>

<script>
  import _ from 'lodash'

  import { Validator } from 'vee-validate'
  import {
    hasNumberValidator,
    hasUpperAndLowerLetterValidator,
    hasUpperCaseValidator,
    hasLowerCaseValidator,
    hasSpecialCharacterValidator
  } from '../services/custom-validators'

  import { createProfileService } from '../services/ServiceContainer'

  Validator.extend('hasNumberValidator', hasNumberValidator)
  Validator.extend('hasUpperAndLowerLetterValidator', hasUpperAndLowerLetterValidator)
  Validator.extend('hasSpecialCharacterValidator', hasSpecialCharacterValidator)
  Validator.extend('hasUpperCaseValidator', hasUpperCaseValidator)
  Validator.extend('hasLowerCaseValidator', hasLowerCaseValidator)

  export default {
    name: 'login-credentials-form',
    inject: ['$validator'],
    props: {
      validationScope: {
        type: String,
        default: 'loginCredentialsValidation'
      },
      value: {
        type: Object,
        default: function () {
          return {
            username: '',
            email: '',
            password: '',
            confirmPassword: ''
          }
        }
      }
    },
    data () {
      return {
        uName: ''
      }
    },
    created () {
      Validator.extend('verify-username', {
        getMessage: field => `The username selected is already in use.  Please enter a new one.`,
        validate: value => {
          return createProfileService.validateUsername({
            params: {
              userName: value
            }
          }).then((response) => {
            return Promise.resolve({ valid: response.data.success })
          }).catch((error) => {
            console.log(error)
            return Promise.reject({ valid: false })
          })
        }
      })
    },
    methods: {
      setValue (key, value) {
        let valueCopy = _.cloneDeep(this.value)
        valueCopy[key] = value
        this.$emit('input', valueCopy)
      },

      togglePassword (el) {
        let newType = el.getAttribute('type') === 'password' ? 'text' : 'password'
        el.setAttribute('type', newType)
        el.focus()
      },
      validateHasANumber: hasNumberValidator.validate,
      validateHasUpperAndLowerLetter: hasUpperAndLowerLetterValidator.validate,
      validateLength (value) {
        return (value.length >= 8 && value.length <= 14)
      }

    },
    watch: {
      uName: function (val) {
        this.value.username = val
      }
    }
  }
</script>

<style lang="scss">
  @import '~my-account-common-css/stylesheets/materialized.scss';

  .tooltips {
    margin-left: 14px;
    h5 {
      font-weight: bold;
      color: black;
    }
    .ok-check {
      color: $md-brand-green;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginCredentialsForm.vue